// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBo3mWQtsjvCHc0Ee2y9ExHnnaFQLfmvrI",
    authDomain: "profuturs-weatherpredict.firebaseapp.com",
    projectId: "profuturs-weatherpredict",
    storageBucket: "profuturs-weatherpredict.firebasestorage.app",
    messagingSenderId: "817132539865",
    appId: "1:817132539865:web:bd4817e719fb52629e93c8",
    measurementId: "G-250H6HZ80E"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);